<script>
  export let page;
  export let id;
</script>

<style>
  main {
    min-height: 100vh;
  }
</style>

<main
  {id}
  class:background-grayLight={page.path !== "/cart"}
  class:background-white={page.path === "/cart"}
  class:fizz-styles={page.path === "/cart"}
>
  <slot />
</main>
